import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import NavigationTabs from '../../constants/NavigationTabs';
import HamburgerNavigation from '../HamburgerNavigation/HamburgerNavigation';
import mobileContainerHeightCSS from '../../constants/mobileContainerHeightCSS';

const propTypes = {
    children: PropTypes.node,
    selectedTab: PropTypes.oneOf([
        NavigationTabs.HOME,
        NavigationTabs.GENERAL,
        NavigationTabs.EMAILS,
        NavigationTabs.CHANGE_PASSWORD,
    ]),
};

const MyAccountLayoutMobile = ({ children, selectedTab }) => {
    return (
        <>
            <div
                css={css`
                    display: flex;
                    flex-direction: column;
                    width: 100vw;
                    overflow: scroll;
                    ${mobileContainerHeightCSS}
                    -webkit-tap-highlight-color: transparent; // Fix for Chrome mobile devices blue highlight on tap
                `}
            >
                <HamburgerNavigation selectedTab={selectedTab} />
                <div
                    css={css`
                        flex-grow: 1;
                        display: flex;
                        flex-direction: column;
                        padding: 2rem;
                    `}
                >
                    {children}
                </div>
            </div>
        </>
    );
};

MyAccountLayoutMobile.propTypes = propTypes;

export default MyAccountLayoutMobile;
